export { default as UniQ } from "./UniQ";
